module.exports = __webpack_public_path__ + "static/media/home-repair.9d0cbe20.jpg";